import { useState } from "react";
import Logo from "../images/BDLogo.png";
import { Link } from "react-router-dom";

export default function Sidebar() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* Logo trigger button — fixed over hero */}
            <button
                onClick={() => setIsOpen(true)}
                aria-label="Open menu"
                className="fixed top-0 left-0 z-30"
            >
                <img src={Logo} className="w-20 m-2" alt="BD Logo" />
            </button>

            {/* Backdrop */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Slide-out panel */}
            <div
                className={`fixed top-0 left-0 h-full w-72 bg-white z-50 shadow-xl flex flex-col transition-transform duration-300 ease-in-out ${
                    isOpen ? "translate-x-0" : "-translate-x-full"
                }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b">
                    <Link to="/" onClick={() => setIsOpen(false)}>
                        <img src={Logo} className="w-16" alt="BD Logo" />
                    </Link>
                    <button
                        onClick={() => setIsOpen(false)}
                        aria-label="Close menu"
                        className="text-gray-500 hover:text-gray-800 text-2xl leading-none"
                    >
                        &times;
                    </button>
                </div>

                {/* Nav links */}
                <nav className="flex flex-col p-4 gap-2 text-gray-800 font-medium">
                    <Link
                        to="/locations"
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-3 rounded-lg hover:bg-gray-100"
                    >
                        Our Locations
                    </Link>
                    <Link
                        to="/contact"
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-3 rounded-lg hover:bg-gray-100"
                    >
                        Contact
                    </Link>
                    <Link
                        to="/apply"
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-3 rounded-lg hover:bg-gray-100"
                    >
                        Apply
                    </Link>
                    <Link
                        to="/acceptedcontainers"
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-3 rounded-lg hover:bg-gray-100"
                    >
                        Accepted Containers
                    </Link>
                    <Link
                        to="/returnprocess"
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-3 rounded-lg hover:bg-gray-100"
                    >
                        Return Process
                    </Link>
                </nav>
            </div>
        </>
    );
}
